import { Route, Switch, useRouteMatch } from "react-router-dom"
import SubjectImportList from "./SubjectImportList"
import ImportsShow from "./ImportsShow"

export default function SubjectImports({ type, basePath }) {
  const match = useRouteMatch()
  const matchUrlHasValue = match.url !== "/"

  const matchUrl = matchUrlHasValue ? match.url : basePath
  const showUrl = `${matchUrl}/:id`

  return (
    <Switch>
      <Route path={showUrl}>
        <ImportsShow backUrl={matchUrl} />
      </Route>
      <Route>
        <SubjectImportList typeSelect={type} showUrl={showUrl} />
      </Route>
    </Switch>
  )
}
